/* eslint-disable no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import {
  Box,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  // Paper,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import CargoLoader from "components/CargoLoader";
import FilterBar, { filterRows } from "components/FilterBar";
import Pagination, { usePagination } from "components/Pagination";
import DeleteContainer from "./delete_container";

function ContainersDetails() {
  const route = useLocation().pathname.split("/").slice(1);
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setloading] = useState(false);
  // const [search, setSearch] = useState(false);
  // function changeboolvalue() {
  //   setSearch(false);
  // }

  const fetchData = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch(
      `https://trust-cargo.co/anas_backend/api/container_details/${route[route.length - 1]}`
    );
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setUsers(data["order_details"]);
    setloading(false);
  };
  useEffect(() => {
    setloading(true);
    fetchData();
  }, []);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const filteredRows = filterRows(users, query);
  const pager = usePagination(filteredRows);
  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SuiTypography variant="h6">Containers Details</SuiTypography>
            </SuiBox>
            <FilterBar
              value={query}
              onChange={setQuery}
              count={filteredRows.length}
              total={users.length}
            />
            {loading ? (
              <div
                style={{
                  width: "1000",
                  height: "50px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CargoLoader />
              </div>
            ) : (
              <>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table">
                  <TableHead>
                    <TableRow style={{ display: "flex" }}>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                          Customer Name
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                          Customer Code
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                          Total CTN
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                          Total T_QTY
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                          Total G_W
                        </TableCell>
                      </Box>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pager.pageRows.map((user) => (
                      <TableRow
                        key={user.name}
                        style={{ marginLeft: "20px" }}
                        sx={{
                          // "&:last-child td, &:last-child th": { border: 0 },
                          display: "flex",
                        }}
                      >
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                            {user.customer_name ?? "-"}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                            {user.customer_id ?? "-"}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                            {user.total_ctn ?? "-"}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                            {user.total_g_w ?? "-"}
                          </TableCell>
                        </Box>
                        <Box>
                          <TableCell sx={{ width: window.innerWidth / 5 }} align="center">
                            {user.total_t_qty ?? "-"}
                          </TableCell>
                        </Box>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination {...pager} />
              </>
            )}
          </Card>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ContainersDetails;
